export const CONTACT_INFO_TEXT = `
Адрес:
127055, г. Москва, ул. Новосущёвская, 15

Почта:
koshergurme1@gmail.com
`